document.addEventListener('DOMContentLoaded', function () {
  initRevelado();
  initGaleriaProducto();
  initSelectorVariantes();
  initPasoActivo();
  initComparador();
});

function initRevelado() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );

  els.forEach(function (el) { observer.observe(el); });
}

function initGaleriaProducto() {
  var wrap = document.querySelector('[data-mt-galeria]');
  if (!wrap) return;

  var principal = wrap.querySelector('[data-mt-galeria-principal]');
  var miniaturas = wrap.querySelectorAll('[data-mt-galeria-mini]');
  if (!principal || !miniaturas.length) return;

  miniaturas.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var nuevaSrc = mini.getAttribute('data-src');
      var nuevoSrcset = mini.getAttribute('data-srcset');
      var nuevoAlt = mini.getAttribute('data-alt') || '';
      if (!nuevaSrc) return;
      principal.src = nuevaSrc;
      if (nuevoSrcset) principal.srcset = nuevoSrcset;
      principal.alt = nuevoAlt;
      miniaturas.forEach(function (m) { m.classList.remove('mt-mini-activa'); });
      mini.classList.add('mt-mini-activa');
    });
  });
}

function initSelectorVariantes() {
  var forms = document.querySelectorAll('[data-mt-producto-form]');
  forms.forEach(function (form) {
    var dataEl = form.querySelector('[data-mt-variantes-json]');
    var selects = form.querySelectorAll('[data-mt-opcion]');
    if (!dataEl || !selects.length) return;

    var variantes;
    try {
      variantes = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var idInput = form.querySelector('input[name="id"]');
    var precioEl = form.querySelector('[data-mt-precio]');
    var precioCompareEl = form.querySelector('[data-mt-precio-comparado]');
    var botonEl = form.querySelector('[data-mt-boton-comprar]');
    var textoBotonBase = botonEl ? botonEl.getAttribute('data-texto-base') : '';
    var textoAgotado = botonEl ? botonEl.getAttribute('data-texto-agotado') : '';

    function formatoMoneda(centavos) {
      return (centavos / 100).toLocaleString(document.documentElement.lang || 'es', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
      });
    }

    function actualizar() {
      var seleccion = Array.from(selects).map(function (s) { return s.value; });
      var variante = variantes.find(function (v) {
        return v.options.every(function (opt, i) { return opt === seleccion[i]; });
      });
      if (!variante) return;

      idInput.value = variante.id;
      if (precioEl) precioEl.textContent = formatoMoneda(variante.price);
      if (precioCompareEl) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioCompareEl.textContent = formatoMoneda(variante.compare_at_price);
          precioCompareEl.style.display = '';
        } else {
          precioCompareEl.style.display = 'none';
        }
      }
      if (botonEl) {
        if (variante.available) {
          botonEl.removeAttribute('disabled');
          botonEl.textContent = textoBotonBase;
        } else {
          botonEl.setAttribute('disabled', 'disabled');
          botonEl.textContent = textoAgotado;
        }
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', actualizar); });
    actualizar();
  });
}

function initComparador() {
  var comparadores = document.querySelectorAll('[data-mt-comparador]');
  comparadores.forEach(function (comparador) {
    var antes = comparador.querySelector('[data-mt-comparador-antes]');
    var asa = comparador.querySelector('[data-mt-comparador-asa]');
    var range = comparador.querySelector('[data-mt-comparador-range]');
    if (!antes || !asa || !range) return;

    function actualizar(valor) {
      antes.style.clipPath = 'inset(0 ' + (100 - valor) + '% 0 0)';
      asa.style.left = valor + '%';
    }

    range.addEventListener('input', function () {
      actualizar(Number(range.value));
    });

    actualizar(Number(range.value));
  });
}

function initPasoActivo() {
  var pasos = document.querySelectorAll('[data-mt-paso]');
  if (!pasos.length) return;
  pasos.forEach(function (paso, i) {
    paso.style.setProperty('--mt-paso-index', i);
  });
}
